import { useEffect, useState } from 'react';

// Holds back a fast-changing value (search typing) until it settles for `delay` ms.
export const useDebouncedValue = (value, delay = 400) => {
    const [debouncedValue, setDebouncedValue] = useState(value);

    useEffect(() => {
        const timer = setTimeout(() => setDebouncedValue(value), delay);
        return () => clearTimeout(timer);
    }, [value, delay]);

    return debouncedValue;
};

export default useDebouncedValue;
